module.exports = __webpack_public_path__ + "KaTeX_Size4-Regular.75820a0a.ttf";